<template>
  <section id="magazine-form">
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ title }}
          </p>
        </header>

        <section id="magazine-body" class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <div class="columns">
              <div class="column is-5">
                <form-group
                  name="name"
                  :label="$t('attributes.name')"
                  label-position="on-border"
                  class="is-flex-grow-1"
                >
                  <b-input
                    v-model="form.name"
                    name="name"
                    :placeholder="
                      $t('message.please_input') + $t('attributes.name')
                    "
                    expanded
                  >
                  </b-input>
                </form-group>

                <form-group
                  name="magazine_date"
                  attribute="attributes.magazine_date"
                  :label="$t('attributes.magazine_date')"
                  label-position="on-border"
                >
                  <b-datepicker
                    v-model="dates"
                    range
                    trap-focus
                    nearby-selectable-month-days
                    :placeholder="
                      $t('message.please_select') + $t('attributes.date_range')
                    "
                    @input="onSelectedDates"
                  />
                </form-group>

                <form-group
                  name="pages"
                  attribute="attributes.magazine_pages"
                  :label="$t('attributes.magazine_pages')"
                  label-position="on-border"
                >
                  <b-input
                    v-model.number="form.pages"
                    name="pages"
                    type="number"
                    min="2"
                    :placeholder="
                      $t('message.please_input') +
                        $t('attributes.magazine_pages')
                    "
                    expanded
                  >
                  </b-input>
                </form-group>

                <div class="is-flex">
                  <div class="is-flex is-flex-grow-0 mr-1">
                    <b-field class="file">
                      <a class="button is-primary" @click="onSelectFile">
                        <b-icon icon="upload"></b-icon>
                        <span>{{ $t('message.please_select_pdf') }}</span>
                      </a>
                    </b-field>
                  </div>

                  <div class="is-flex is-flex-grow-1 mb-4">
                    <form-group
                      name="file_path"
                      attribute="message.please_select_pdf"
                      :label="$t('attributes.magazine_file_path')"
                      label-position="on-border"
                      class="is-flex-grow-1"
                    >
                      <b-input
                        v-model="form.file_path"
                        name="file_path"
                        expanded
                        readonly
                      >
                      </b-input>
                    </form-group>
                  </div>
                </div>

                <form-group
                  name="file_name"
                  attribute="message.please_select_pdf"
                  :label="$t('attributes.magazine_file_name')"
                  label-position="on-border"
                >
                  <b-input
                    v-model="form.file_name"
                    name="file_name"
                    expanded
                    readonly
                  >
                  </b-input>
                </form-group>

                <div class="mt-1 is-size-6">
                  <p class="has-text-weight-bold">
                    <span class="has-text-danger">
                      請將DM的「PDF」及「JPG」檔上傳到相同路徑下，然後選擇「PDF」檔案；
                    </span>
                  </p>
                  <p class="has-text-weight-bold">
                    <span class="has-text-danger-dark">
                      圖檔只能使用JPG檔格式；
                    </span>
                    <span class="has-text-danger-dark">
                      請確認以下檔案都已上傳。
                    </span>
                  </p>
                  <ul class="has-text-weight-bold">
                    <li class="pl-2">- PDF：{{ this.fileName }}.pdf</li>
                    <li class="pl-2">- 封面：{{ this.fileName }}.jpg</li>
                    <li class="pl-2">
                      - 內頁：{{ this.fileName
                      }}<span class="has-text-danger">2</span>.jpg ~
                      {{ this.fileName
                      }}<span class="has-text-danger">{{ this.pages }}</span
                      >.jpg
                    </li>
                  </ul>
                </div>
              </div>

              <div class="column is-7">
                <form-group name="desc">
                  <div class="content">
                    <editor
                      ref="desc_editor"
                      v-model="form.desc"
                      image-type="Magazines"
                      :height="200"
                    ></editor>
                  </div>
                </form-group>
              </div>
            </div>

            <div
              class="columns is-desktop pt-2"
              style="border-top: dashed 1px gray"
            >
              <div class="column">
                <div class="is-flex is-flex-direction-column">
                  <p class="is-size-6 has-text-weight-semibold mb-3">
                    {{
                      $t('attributes.setting') +
                        $t('attributes.magazine_link_list')
                    }}
                    <span class="has-text-danger">(名稱或頁數未填則忽略)</span>
                  </p>

                  <b-table
                    :data="link_list"
                    :mobile-cards="false"
                    narrowed
                    bordered
                    draggable
                    @dragstart="linkDragstart"
                    @drop="linkDrop"
                    @dragover="linkDragover"
                    @dragleave="linkDragleave"
                  >
                    <b-table-column
                      :label="$t('attributes.title')"
                      v-slot="props"
                    >
                      <b-input
                        v-model="props.row.title"
                        :placeholder="
                          $t('message.please_input') + $t('attributes.title')
                        "
                      >
                      </b-input>
                    </b-table-column>
                    <b-table-column
                      :label="$t('attributes.magazine_page')"
                      v-slot="props"
                    >
                      <b-input
                        v-model.number="props.row.page"
                        type="number"
                        min="2"
                        :max="form.pages"
                        :placeholder="
                          $t('message.please_input') +
                            $t('attributes.magazine_page')
                        "
                      >
                      </b-input>
                    </b-table-column>

                    <template #empty>
                      <section class="section">
                        <div class="content has-text-grey has-text-centered">
                          <p>未設定</p>
                        </div>
                      </section>
                    </template>
                  </b-table>

                  <b-button class="is-primary mt-2" @click="addLink">
                    {{
                      $t('attributes.add') + $t('attributes.magazine_link_list')
                    }}
                  </b-button>
                </div>
              </div>

              <div class="column">
                <div class="is-flex is-flex-direction-column">
                  <p class="is-size-6 has-text-weight-medium mb-3">
                    {{
                      $t('attributes.setting') +
                        $t('attributes.magazine_content_list')
                    }}
                    <span class="has-text-danger">(名稱或頁數未填則忽略)</span>
                  </p>

                  <b-table
                    :data="content_list"
                    :mobile-cards="false"
                    narrowed
                    bordered
                    draggable
                    @dragstart="contentDragstart"
                    @drop="contentDrop"
                    @dragover="contentDragover"
                    @dragleave="contentDragleave"
                  >
                    <b-table-column
                      :label="$t('attributes.title')"
                      v-slot="props"
                    >
                      <b-input
                        v-model="props.row.title"
                        :placeholder="
                          $t('message.please_input') + $t('attributes.title')
                        "
                      >
                      </b-input>
                    </b-table-column>
                    <b-table-column
                      :label="$t('attributes.magazine_page')"
                      v-slot="props"
                    >
                      <b-input
                        v-model.number="props.row.page"
                        type="number"
                        min="2"
                        :max="form.pages"
                        :placeholder="
                          $t('message.please_input') +
                            $t('attributes.magazine_page')
                        "
                      >
                      </b-input>
                    </b-table-column>

                    <template #empty>
                      <section class="section">
                        <div class="content has-text-grey has-text-centered">
                          <p>未設定</p>
                        </div>
                      </section>
                    </template>
                  </b-table>

                  <b-button class="is-primary mt-2" @click="addContent">
                    {{
                      $t('attributes.add') +
                        $t('attributes.magazine_content_list')
                    }}
                  </b-button>
                </div>
              </div>
            </div>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <div class="is-flex is-justify-content-end" style="width: 100%;">
            <b-button :loading="sending" @click="$parent.close()">
              {{ $t('attributes.close') }}
            </b-button>
            <b-button :loading="sending" type="is-primary" native-type="submit">
              {{ isUpdate ? $t('attributes.update') : $t('attributes.add') }}
            </b-button>
          </div>
        </footer>
      </div>
    </form>

    <b-loading
      :active.sync="isLoading"
      :is-full-page="false"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { OpenMagazineFinder } from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'MagazineForm',
  components: { Editor },

  props: {
    magazine: {
      type: Object,
      required: true
    }
  },
  data() {
    const isUpdate = !!this.magazine.id
    const title = isUpdate
      ? this.$t('attributes.modify')
      : this.$t('attributes.add')

    const link_list = [...this.magazine.link_list, this.defaultLink()]
    const content_list = [...this.magazine.content_list, this.defaultLink()]

    return {
      isUpdate: isUpdate,
      title: title,

      loading: false,
      sending: false,
      dates: this.extractDates(this.magazine),
      link_list: link_list,
      content_list: content_list,
      form: this.extractFormValues(this.magazine),

      linkDraggingRow: null,
      linkDraggingRowIndex: null,
      contentDraggingRow: null,
      contentDraggingRowIndex: null
    }
  },
  validations: {
    form: {
      date: { required, maxLength: maxLength(30) },
      name: { required, maxLength: maxLength(20) },
      desc: { maxLength: maxLength(500) },
      pages: { required },
      file_path: { required },
      file_name: { required },
      link_list: {},
      content_list: {}
    }
  },
  computed: {
    isLoading() {
      return this.loading || this.sending
    },
    fileName() {
      return (
        this.form.file_name || `[${this.$t('attributes.magazine_file_name')}]`
      )
    },
    pages() {
      return this.form.pages || '[頁數]'
    }
  },
  methods: {
    extractFormValues(data) {
      const dates = this.extractDates(data)

      return {
        id: data.id,
        code: data.code,
        date: this.concatDates(dates),
        name: data.name,
        desc: data.desc,
        pages: data.pages,
        file_path: data.file_path,
        file_name: data.file_name,
        link_list: data.link_list,
        content_list: data.content_list
      }
    },
    onSelectedDates() {
      this.form.date = this.concatDates(this.dates)
    },
    async onSend() {
      this.form.desc = this.$refs.desc_editor.getData()
      this.form.link_list = this.link_list.filter(l => l.title && l.page)
      this.form.content_list = this.content_list.filter(l => l.title && l.page)

      this.$v.$touch()

      if (this.$v.$invalid) {
        notifyService.error('資料錯誤')
        return
      }

      this.$emit('send', this.form)
    },
    extractDates(magazine) {
      let dates
      const date = magazine.date
        ? magazine.date.split('-').map(item => item.trim())
        : []
      if (date.length === 2) {
        const startDate = this.$dayjs(date[0]).toDate()
        const endDate = this.$dayjs(date[1]).toDate()
        dates = [startDate, endDate]
      } else {
        const today = this.$dayjs()
        const startDate = today.toDate()
        const endDate = today.add(1, 'month').toDate()
        dates = [startDate, endDate]
      }

      return dates
    },
    concatDates(dates) {
      return `${this.formatDateDot(dates[0])} - ${this.formatDateDot(dates[1])}`
    },
    async onSelectFile() {
      try {
        const file = await OpenMagazineFinder()
        const ext = file.substring(file.lastIndexOf('.') + 1)
        const pathName = file.substring(0, file.lastIndexOf('.'))
        const path = pathName.substring(0, file.lastIndexOf('/'))
        const name = pathName.substring(file.lastIndexOf('/') + 1)

        if (ext !== 'pdf') {
          notifyService.error(this.$t('message.please_select_pdf'))
        }

        this.form.file_path = path
        this.form.file_name = name
      } catch (e) {
        notifyService.error(e)
      }
    },
    addLink() {
      this.link_list.push(this.defaultLink())
    },
    addContent() {
      this.content_list.push(this.defaultLink())
    },
    defaultLink() {
      return {
        type: 'anchor',
        title: '',
        page: 2,
        url: null
      }
    },
    linkDragstart(payload) {
      this.linkDraggingRow = payload.row
      this.linkDraggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    linkDragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    linkDragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    linkDrop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const linkDroppedOnRowIndex = payload.index

      let items = [...this.link_list]

      items.splice(this.linkDraggingRowIndex, 1)

      items.splice(linkDroppedOnRowIndex, 0, this.linkDraggingRow)

      this.link_list = items
    },
    contentDragstart(payload) {
      this.contentDraggingRow = payload.row
      this.contentDraggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    contentDragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    contentDragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    contentDrop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const contentDroppedOnRowIndex = payload.index

      let items = [...this.content_list]

      items.splice(this.contentDraggingRowIndex, 1)

      items.splice(contentDroppedOnRowIndex, 0, this.contentDraggingRow)

      this.content_list = items
    }
  }
}
</script>
